<template>
	<div class="container-fluid no-padding-sides">
		<div id="carousel-about" class="carousel carousel-about slide" data-ride="carousel" data-interval="false">
			<!-- <i class="fa fa-4x fa-repeat repeat-carousel" v-show="id == 8"></i> -->
			  <!-- Wrapper for slides -->
			<div class="carousel-inner" role="listbox">
			    <div class="item item-about" v-for="(index, slider) in sliders" :class="{ active: isFirst(slider) }" :style="`background-image: url(${setUrlImage(slider.id)});`" :data-id="index + 1"></div>
			    <!-- <div class="item item-about item-about-bg-2" data-id="2"></div>
			    <div class="item item-about item-about-bg-3" data-id="3"></div>
			    <div class="item item-about item-about-bg-4" data-id="4"></div>
			    <div class="item item-about item-about-bg-5" data-id="5"></div>
			    <div class="item item-about item-about-bg-6" data-id="6"></div>
			    <div class="item item-about item-about-bg-7" data-id="7"></div>
			    <div class="item item-about item-about-bg-8" data-id="8"></div>
			    <div class="item item-about item-about-bg-9" data-id="9"></div> -->
			</div>

			<!-- Left and right controls -->
			<!-- <span class="left carousel-control" href="#carousel-about" role="button" data-slide="prev">
				<img class="img-responsive chevron-left" src="../../images/chevron-left.png" alt="">
				<span class="sr-only"></span>
			</span> -->
			<span class="right carousel-control" href="#carousel-about" role="button" data-slide="next" v-if="sliders_count > 1">
				<i class="fa fa-arrow-right about-caret" v-if="id != sliders_count"></i>
				<i class="fa fa-repeat repeat-carousel" v-if="id == sliders_count"></i>
				<!-- <img class="img-responsive chevron-right" src="../../images/chevron-right-black.png" alt=""> -->
				<span class="sr-only"></span>
			</span>
		</div>
	</div>
</template>

<style scoped>
	.container-fluid {
		margin-top: 10px;
	}
</style>

<script>
import { api_base } from '../../store/api'

export default {
	data () {
		return {
			id: 0,
			sliders: [],
			current: {}
		};
	},

	computed: {
		sliders_count () {
			if (this.sliders) {
				return this.sliders.length - 1
			}
		}
	},

	methods: {
		carouselOneSide () {
			var vm = this;

			$('.carousel-about').on('slide.bs.carousel', function (e) {
				vm.id = $('.item.item-about.active').data('id');
			});

			// $('.carousel-about').on('slid.bs.carousel', function (e) {
			// 	vm.id = $('.item.item-about.active').data('id');
			// });

			$('.repeat-carousel').on('click', function () {
				$('.carousel-about').carousel(0);
			});
		},

		setUrlImage (id) {
			return `${api_base}/sliders2/${id}`
		},

		getSliders () {
			let vm = this

			$.get(`${api_base}/sliders2`, function (res) {
				vm.sliders = res
			})
		},

		isFirst (slider) {
			if (slider) {
				return slider.id === this.sliders[0].id
			}
		}
	},

	ready () {
		this.carouselOneSide()
		this.getSliders()
	}
}
</script>


// WEBPACK FOOTER //
// Carousel.vue?c7849d6e